




import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'AccountsWrapper',
  
  data() {
    return {
      ListAccounts: null,
      LocationsList: null
    }
  },

  computed: {
    ...mapGetters({
      isRevampEnabled: 'featureFlags/getForCompany'
    }),

    currentComponent() {
      return this.isRevampEnabled('enable-97-297-ui-revamp') ? this.LocationsList : this.ListAccounts
    }
  },

  async created() {
    // Dynamically import both components
    const [ListAccounts, LocationsList] = await Promise.all([
      import('@/pmd/pages/agency/ListAccounts.vue'),
      import('@/pmd/pages/LocationsList.vue')
    ])
    
    this.ListAccounts = ListAccounts.default
    this.LocationsList = LocationsList.default
  },

  watch: {
    // Watch for feature flag changes
    'isRevampEnabled': {
      immediate: true,
      handler() {
        // Force component re-render when feature flag changes
        this.$forceUpdate()
      }
    }
  }
})
